import React, { useState } from 'react'
import { Box, Typography, TextField } from '@mui/material'

interface SearchInputProps {
  title?: string
  placeholder?: string
  value: string
  onChange: (value: string) => void
  onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void
  autoChange?: boolean
  autoBlur?: boolean
}

const SearchInput: React.FC<SearchInputProps> = ({
  title = 'ค้นหา',
  placeholder,
  value,
  onChange,
  onKeyDown,
  autoChange = false,
  autoBlur = false,
}) => {
  const [inputValue, setInputValue] = useState<string>(value)

  React.useEffect(() => {
    setInputValue(value)
  }, [value])

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value
    setInputValue(newValue)
    if (autoChange) {
      onChange(newValue)
    }
  }

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      onChange(inputValue)
      onKeyDown?.(e)
    }
  }

  const handleBlur = () => {
    console.log('handleBlur inputValue:', inputValue)
    onChange(inputValue)
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexGrow: 1,
        flexDirection: 'column',
      }}
    >
      <Typography
        variant="body2"
        sx={{ mb: 1, fontWeight: 500, color: '#333' }}
      >
        {title}
      </Typography>
      <TextField
        placeholder={placeholder}
        value={inputValue}
        onChange={handleChange}
        onKeyDown={handleKeyDown}
        onBlur={autoBlur ? handleBlur : undefined}
      />
    </Box>
  )
}

export default SearchInput
